import { createIcon } from '../createIcon';

export const FeatherIconConfig = {
  name: 'FeatherIcon',
  height: 512,
  width: 512,
  svgPath: 'M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z',
  yOffset: 0,
  xOffset: 0,
};

export const FeatherIcon = createIcon(FeatherIconConfig);

export default FeatherIcon;